// Explicit CSS entry for the gate primitive set. Consumers import this
// exactly once from the first route that renders any gate primitive.
// Keeps the barrel CSS-free so Next.js can tree-shake type-only imports.
import './gate.css';
